import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { getDateWithFormat } from "../../helpers/Utils";

import {
  AVAILABLITY_LIST_GET_LIST
} from "../actions";

import {
  getAvailablityListSuccess,
  getAvailablityListError
} from "./actions";

import availablityListData from "../../data/room.list.json";

const getAvailablityListRequest = async () => {
    const rooms = availablityListData.header;  
    const roomdetails=availablityListData.details;
    //console.log(rooms);
    console.log(roomdetails);
  return await new Promise((success, fail) => {
    setTimeout(() => {         
        success({rooms,roomdetails});
    }, 2000);
  })
    .then(response => response)
    .catch(error => error);
};

function* getAvailablityListItems() {
  try {
    const response = yield call(getAvailablityListRequest);
    const { rooms, roomdetails } = response;
    // console.log("rooms");
    // console.log(rooms);
    
    yield put(getAvailablityListSuccess(rooms,roomdetails));
  } catch (error) {
    yield put(getAvailablityListError(error));
  }
}
export function* watchGetList() {
    yield takeEvery(AVAILABLITY_LIST_GET_LIST, getAvailablityListItems);
  }
  
export default function* rootSaga() {
    yield all([fork(watchGetList)]);
  }


